/* eslint-disable @typescript-eslint/no-unused-vars */

import Swiper from 'swiper/bundle';

/* Slider blocs carousel */
var carousel_swiper = $('.carousel-swiper');
carousel_swiper.each( (index, carousel) => {
  var carousel_id = carousel.getAttribute('id');

  new Swiper('#'+carousel_id, {
    slidesPerView: 'auto',
    spaceBetween: 5,
    centeredSlides: true,
    loop: true,
    navigation: {
      nextEl: '.next-'+carousel_id ,
      prevEl: '.prev-'+carousel_id,
    },
    breakpoints: {
      768: {
        spaceBetween: 10,

      },
    },
  });
});

/* Carousel partenaires */
new Swiper('.partners-swiper', {
  slidesPerView: 'auto',
  spaceBetween: 10,
  centeredSlides: true,
  loop: true,
  navigation: {
    nextEl: '.next-partners',
    prevEl: '.prev-partners',
  },
  breakpoints: {
    768: {
      spaceBetween: 15,
    },
    1200: {
      spaceBetween: 15,
      slidesPerView: 4,
      centeredSlides: false,
    },
  },
});

/* Posts filters carousel */
var posts_filters_swiper = new Swiper('.posts-filters-swiper', {
  slidesPerView: 'auto',
  spaceBetween: 16,
  freeMode: true,
  grabCursor: true,
});

if($('.posts-filters-swiper').length > 0) {
  var active_index_posts = $('.posts-filters-swiper .swiper-slide:has(.active)').attr('data-index');
  posts_filters_swiper.slideTo(active_index_posts);
}

/* Taxo filters carousel */
var taxo_filters_swiper = new Swiper('.taxo-filters-swiper', {
  slidesPerView: 'auto',
  spaceBetween: 30,
  freeMode: true,
  grabCursor: true,
  breakpoints: {
    992: {
      spaceBetween: 60,
    },
  },
  on: {
    lock: function () {
      $('.taxo-filters-swiper').addClass('nothing-to-swipe');
    },
  },
});

if($('.taxo-filters-swiper').length > 0) {
  var active_index = $('.taxo-filters-swiper .swiper-slide:has(.active)').attr('data-index');
  taxo_filters_swiper.slideTo(active_index);

  $('.taxo-next').on('click', () => {
    taxo_filters_swiper.slideNext();
  });

  $('.taxo-prev').on('click', () => {
    taxo_filters_swiper.slidePrev();
  });
}

/* Block types carousel */
new Swiper('.block-types-swiper', {
  slidesPerView: 2.3,
  spaceBetween: 35,
  freeMode: true,
  grabCursor: true,
  breakpoints: {
    560: {
      slidesPerView: 3.3,
    },
    768: {
      slidesPerView: 4.3,
    },
    992: {
      slidesPerView: 5.3,
    },
    1200: {
      slidesPerView: 'auto',
    },
  },
});

/* Block expertises carousel - seulement sur ecran >1200px */
/* eslint-disable unicorn/no-useless-undefined */
var block_expertises_swiper = undefined;

function initExpertisesSwiper() {
  if(window.matchMedia('(max-width: 1199px)').matches && block_expertises_swiper == undefined) {
    block_expertises_swiper = new Swiper('.block-expertises-swiper', {
      slidesPerView: 1.3,
      spaceBetween: 0,
      centeredSlides: true,
      initialSlide: 1,
      breakpoints: {
        560: {
          slidesPerView: 1.8,
          spaceBetween: 18,
        },
        768: {
          slidesPerView: 2.2,
          spaceBetween: 18,
        },
        992: {
          slidesPerView: 2.8,
          spaceBetween: 30,
          centeredSlides: false,
          initialSlide: 0,
        },
      },
    });
  } else if (window.matchMedia('(min-width: 1200px)').matches && block_expertises_swiper != undefined) {
    block_expertises_swiper.destroy();
    block_expertises_swiper = undefined;
  }
}
/* eslint-enable unicorn/no-useless-undefined */

// initialization
initExpertisesSwiper();

// initialization on window resize
$(window).on('resize', function(){
    initExpertisesSwiper();
});

/* Events - Actus */
new Swiper('.events-swiper', {
  slidesPerView: 1.3,
  spaceBetween: 0,
  centeredSlides: true,
  breakpoints: {
    768: {
      slidesPerView: 1.8,
      spaceBetween: 18,
      centeredSlides: false,
    },
    992: {
      slidesPerView: 3,
      spaceBetween: 18,
      centeredSlides: false,
    },
    1400: {
      slidesPerView: 3,
      centeredSlides: false,
      spaceBetween: 30,
    },
  },
});

/* Jobs others */
var jobs_swiper = new Swiper('.jobs-swiper', {
  slidesPerView: 1.3,
  spaceBetween: 0,
  centeredSlides: true,
  breakpoints: {
    768: {
      slidesPerView: 1.8,
    },
    992: {
      slidesPerView: 3,
      spaceBetween: 18,
      centeredSlides: false,
    },
    1400: {
      slidesPerView: 3,
      centeredSlides: false,
      spaceBetween: 30,
    },
  },
});

if($('.jobs-swiper').length > 0) {
  jobs_swiper.slideTo(1);
}

/* Testimonials */
new Swiper('.testimonials-swiper', {
  slidesPerView: 'auto',
  spaceBetween: 20,
  centeredSlides: true,
  initialSlide: 2,
  navigation: {
    nextEl: '.next-testimony',
    prevEl: '.prev-testimony',
  },
});

/* Trainings others */
var trainings_swiper = new Swiper('.trainings-swiper', {
  slidesPerView: 1.3,
  spaceBetween: 0,
  centeredSlides: true,
  breakpoints: {
    560: {
      slidesPerView: 1.8,
    },
    768: {
      slidesPerView: 2.2,
    },
    992: {
      slidesPerView: 3,
      spaceBetween: 18,
      centeredSlides: false,
    },
    1400: {
      slidesPerView: 3,
      centeredSlides: false,
      spaceBetween: 30,
    },
  },
});

if($('.trainings-swiper').length > 0) {
  trainings_swiper.slideTo(1);
}

/* Expertises carousel fiche formation */
new Swiper('.training-expertises-swiper', {
  slidesPerView: 'auto',
  spaceBetween: 35,
  freeMode: true,
  grabCursor: true,
  navigation: {
    nextEl: '.next-taxo',
    prevEl: '.prev-taxo',
  },
});

/* Training anchors carousel */
new Swiper('.anchors-swiper', {
  slidesPerView: 'auto',
  spaceBetween: 35,
  freeMode: true,
  grabCursor: true,
  breakpoints: {
    1200: {
      spaceBetween: 0,
    },
  },
});

/* Home expertises carousel */
new Swiper('.home-expertises-swiper', {
  slidesPerView: 'auto',
  spaceBetween: 0,
  centeredSlides: true,
  initialSlide: 1,
  breakpoints: {
    1200: {
      initialSlide: 2,
    },
  },
  navigation: {
    nextEl: '.next-expertise',
    prevEl: '.prev-expertise',
  },
});

/* eslint-enable @typescript-eslint/no-unused-vars */
